if (typeof jQuery !== 'undefined') {
  jQuery(document).ready(function ($) {

    var $element_feature_product = $('.custom-featured-products');
    if ($element_feature_product.length) {
      var column__lg = $element_feature_product.data("column-desktop");
      $element_feature_product.slick({
        dots: false,
        arrows: true,
        slidesToShow: column__lg,
        slidesToScroll: 1,
        autoplay: false,
        autoplaySpeed: 3000,
        infinite: false,
        responsive: [
          {
            breakpoint: 1200,
            settings: {
              slidesToShow: 3
            }
          },
          {
            breakpoint: 767,
            settings: "unslick" // Mobile will not have slick functionality
          }
        ]
      });
    }

    var $element_subbanner = $('.sub_banners_block');
    if ($element_subbanner.length) {
      $element_subbanner.slick({
        dots: false,
        arrows: false,
        slidesToShow: 6,
        slidesToScroll: 1,
        autoplay: false,
        autoplaySpeed: 3000,
        infinite: false,
        responsive: [
          {
            breakpoint: 1200,
            settings: {
              slidesToShow: 4
            }
          },
          {
            breakpoint: 767,
            settings: {
              slidesToShow: 4
            }
          }
        ]
      });
    }

    var currentUrl = window.location.href;
    $('.support_sidemenu .side_link').each(function() {
      if (this.href === currentUrl) {
        $(this).addClass('active');
      }
    });

  });
}

document.addEventListener('DOMContentLoaded', () => {
  const priceFilterItems = document.querySelectorAll('.price-filter li');

  if (!priceFilterItems.length) return;

  // Function to normalize numbers by removing commas and decimals
  function normalizeNumber(value) {
    if (!value || typeof value !== 'string') return '';
    return value.replace(/,/g, '').split('.')[0];
  }

  function formatNumber(value) {
    if (!value || typeof value !== 'string') return '';
    return value.replace(/,/g, '').trim();
  }

  function triggerInputChange(input) {
    if (!input) return;
    const inputEvent = new Event('input', { bubbles: true });
    input.dispatchEvent(inputEvent);

    const changeEvent = new Event('change', { bubbles: true });
    input.dispatchEvent(changeEvent);
  }

  function clearFields(inputs, callback) {
    let clearedCount = 0;

    inputs.forEach((input) => {
      if (!input) { clearedCount++; return; }
      input.value = '';
      const inputEvent = new Event('input', { bubbles: true });
      input.dispatchEvent(inputEvent);

      const changeEvent = new Event('change', { bubbles: true });
      input.dispatchEvent(changeEvent);

      clearedCount++;
      if (clearedCount === inputs.length && callback) {
        callback();
      }
    });
  }

  // Function to add 'selected' class based on input values
  function applySelectedClass() {
    const minInput = document.querySelector('price-range input[name="filter.v.price.gte"]');
    const maxInput = document.querySelector('price-range input[name="filter.v.price.lte"]');

    if (minInput && maxInput) {
      const minValue = minInput.value ? normalizeNumber(minInput.value.trim()) : '';
      const maxValue = maxInput.value ? normalizeNumber(maxInput.value.trim()) : '';

      if (minValue && maxValue) {
        priceFilterItems.forEach((item) => {
          const itemMin = item.getAttribute('data-min');
          const itemMax = item.getAttribute('data-max');

          if (minValue === itemMin && maxValue === itemMax) {
            item.classList.add('selected'); // Add 'selected' class to the matching <li>
          } else {
            item.classList.remove('selected'); // Ensure other <li>s do not have the class
          }
        });
      }
    }
  }

  // Function to handle click event
  function handleClick(item) {
    // Remove 'selected' class from all siblings
    priceFilterItems.forEach((sibling) => {
      sibling.classList.remove('selected');
    });

    // Add 'selected' class to the clicked item
    item.classList.add('selected');

    // Get min and max price values
    const minPrice = item.getAttribute('data-min');
    const maxPrice = item.getAttribute('data-max');

    // Get the price range inputs
    const minInput = document.querySelector('price-range input[name="filter.v.price.gte"]');
    const maxInput = document.querySelector('price-range input[name="filter.v.price.lte"]');

    // Guard: only proceed if both inputs exist
    if (!minInput || !maxInput) return;

    // Clear and set new values for the inputs
    clearFields([minInput, maxInput], () => {
      minInput.value = formatNumber(minPrice);
      maxInput.value = formatNumber(maxPrice);
      triggerInputChange(minInput);
      triggerInputChange(maxInput);
    });
  }

  // On click, update selected class and input values
  priceFilterItems.forEach((item) => {
    item.addEventListener('click', () => handleClick(item));
  });

  // Apply 'selected' class on page load
  applySelectedClass();
});
